import { FC } from 'react';

import { Star } from 'lucide-react';

import { useComputedUserLevels } from './hooks';

import css from './PointsAndVip.module.css';

import { ProfileCard } from 'v2/components/profileCard/ProfileCard';
import { Nullable } from 'v2/types';
import { LevelModel } from 'v2/types/LevelModel';
import { UserModel } from 'v2/types/UserModel';
import { TournamentBalanceDto, UserActiveTicketsDto } from 'v2/types/UserProfileModel';
import { VipLevelModel } from 'v2/types/VipLevelModel';
import { formatNumber } from 'v2/utils';

interface PointsAndVipProps {
  user: UserModel;
  balance?: Nullable<TournamentBalanceDto>;
  activeTickets?: UserActiveTicketsDto;
  vipLevels?: VipLevelModel[];
  levels?: LevelModel[];
}

export const PointsAndVip: FC<PointsAndVipProps> = ({ user, balance, activeTickets, vipLevels, levels }) => {
  const { vipLevelLabel, levelLabel } = useComputedUserLevels({ user, vipLevels, levels });

  return (
    <ProfileCard title="Points & VIP" icon={<Star width={18} height={18} />}>
      <div className={css.statsGrid}>
        <StatRow label="VIP LEVEL" value={vipLevelLabel} />

        <StatRow label="VIP POINTS" value={formatNumber(user.levelVipPoints)} />

        <StatRow label="LEVEL" value={levelLabel} />

        <StatRow label="LEVEL POINTS" value={formatNumber(user.levelPoints)} />

        <StatRow label="DIAMONDS" value={formatNumber(user.diamonds)} />

        {balance !== undefined && (
          <StatRow
            label="FUNS (Active Tournament)"
            value={balance === null ? 'No active tournament' : formatNumber(balance.balance)}
          />
        )}

        {activeTickets !== undefined && (
          <StatRow label="TICKETS (Active)" value={formatNumber(activeTickets.contestTicketsCount)} />
        )}
      </div>
    </ProfileCard>
  );
};

const StatRow: FC<{ label: string; value: string }> = ({ label, value }) => (
  <div className={css.statRow}>
    <span className={css.statLabel}>{label}</span>

    <span className={css.statValue}>{value}</span>
  </div>
);
